// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__1GLtH","Icon":"Languages_Icon__mvj7p","LanguagesSelect":"Languages_LanguagesSelect__Bl6a-","minimalist":"Languages_minimalist__3KzqM"};